const NAME_SPACE = 'jbp-commitment-changes-log'

export const TRANSLATION_KEYS = {
  title: `${NAME_SPACE}-user-info`,
  headFin: `${NAME_SPACE}-head-fin`,
  headUnits: `${NAME_SPACE}-head-units`,
  headSob: `${NAME_SPACE}-head-sob`,
  ok: `${NAME_SPACE}-ok`,
  category: `${NAME_SPACE}-category`,
  placeholder: `${NAME_SPACE}-placeholder`,
}
